export enum DndMode {
  IDLE = 'idle',
  DRAG = 'drag',
}
